import {
  PRICE_LOGS_URL,
  BACKING_ESTIMATE_URL,
} from '../../@crema/services/ApiConfig';
import {Action, Dispatch} from 'redux';
import {
  FETCH_PRICE_CORRECTION_LOGS,
  FETCH_PRICE_CORRECTION_LOGS_ERROR,
  FETCH_PRICE_CORRECTION_LOGS_SUCCESS,
  FETCH_BACKING_ESTIMATE,
  FETCH_BACKING_ESTIMATE_SUCCESS,
  FETCH_BACKING_ESTIMATE_ERROR,
  PriceCorrectionLogsActionTypes,
} from '../../types/actions/PriceCorrectionLogs.actions';
import {showError} from './Common';
import {ApiActionCall, ApiActionTypes} from './Api';
import {
  IPriceCorrectionLogs,
  IBackingEstimate,
} from '../../types/models/PriceCorrectionLogs';
import {logger} from '../../shared/logger';

export const fetchPriceCorrectionLogs = () => async (
  dispatch: Dispatch<ApiActionCall | PriceCorrectionLogsActionTypes>,
) => {
  dispatch({type: FETCH_PRICE_CORRECTION_LOGS});

  const onSuccess = (payload: IPriceCorrectionLogs) => ({
    type: FETCH_PRICE_CORRECTION_LOGS_SUCCESS,
    payload,
  });
  const onFailure = (message: string) => (dispatch: Dispatch<Action>) => {
    logger.error(message);
    dispatch({type: FETCH_PRICE_CORRECTION_LOGS_ERROR});
    dispatch(showError('Failed to fetch exchange rate.'));
  };

  dispatch({
    type: ApiActionTypes.API_CALL,
    payload: {
      url: PRICE_LOGS_URL,
      method: 'GET',
      label: 'Fetch exchange rate',
      onSuccess,
      onFailure,
    },
  });
};

export const fetchBackingEstimate = (
  exchange: string,
  targetPrice: number,
) => async (
  dispatch: Dispatch<ApiActionCall | PriceCorrectionLogsActionTypes>,
) => {
  dispatch({type: FETCH_BACKING_ESTIMATE});

  const onSuccess = (payload: IBackingEstimate) => ({
    type: FETCH_BACKING_ESTIMATE_SUCCESS,
    payload,
  });
  const onFailure = (message: string) => (dispatch: Dispatch<Action>) => {
    logger.error(message);
    dispatch({type: FETCH_BACKING_ESTIMATE_ERROR});
    dispatch(showError('Failed to fetch backing estimate.'));
  };

  dispatch({
    type: ApiActionTypes.API_CALL,
    payload: {
      url: BACKING_ESTIMATE_URL.replace(':exchangeSlug', exchange),
      method: 'POST',
      data: {targetPrice},
      label: 'Fetch backing estimate',
      onSuccess,
      onFailure,
    },
  });
};
